module.exports = __webpack_public_path__ + "static/media/conexaoescolar-pesquisa.e5fef8a1.png";